import Consent from '../components/Consent';

const ConsentPage = () => <Consent />;

export default ConsentPage;
